import { ApolloProvider } from "@apollo/client";
import { clientNeoAuth } from "@neonumy/api-clients";
import { NotificationProvider, ThemeProvider } from "@neonumy/neonumy-ui";
import { ConfigProvider as ConfigProvider5 } from "antd";
import i18n from "config/i18n/i18n";
import { routes } from "config/routes";
import dayjs from "dayjs";
import "dayjs/locale/en";
import "dayjs/locale/fr";
import { CookiesProvider } from "react-cookie";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { I18nextProvider } from "react-i18next";
import { RouterProvider } from "react-router-dom";

import "@neonumy/neonumy-ui/lib/index.css";
import "resources/styles/main.less";

dayjs.locale(i18n.language as "fr" | "en");

// Static antd v5 calls (Modal.confirm, message) render outside the React tree.
ConfigProvider5.config({
  prefixCls: "ant5",
  holderRender: children => <ThemeProvider>{children}</ThemeProvider>,
});

export default function App(): React.JSX.Element {
  return (
    <CookiesProvider>
      <ApolloProvider client={clientNeoAuth}>
        <I18nextProvider i18n={i18n}>
          <ThemeProvider>
            <NotificationProvider>
              <DndProvider backend={HTML5Backend}>
                <RouterProvider router={routes} />
                <div id="dwtcontrolContainer" />
              </DndProvider>
            </NotificationProvider>
          </ThemeProvider>
        </I18nextProvider>
      </ApolloProvider>
    </CookiesProvider>
  );
}
